export default "__VITE_ASSET__AXKz7snA__"